import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NodesService } from '../service/nodes.service';
import { UserProfileService } from '../../user-profile/service/user-profile.service';
import { Node } from '../model/node.model';
import { LOGINDETAILS } from '../../system/accounts/model/login-audit';
import { MsgModel } from '../../common-components/msg/model/msg.model';

@Component({
    selector: 'app-node-control',
    templateUrl: './node-control.component.html',
    styleUrl: './node-control.component.scss'
})
export class NodeControlComponent implements OnInit {
    @Input() node: Node;
    @Output() nodeChange: EventEmitter<Node> = new EventEmitter<Node>();
    @Input() noReload: boolean = false;

    currentUser: LOGINDETAILS;
    isEditor: boolean = false;
    hasEditors: boolean = false;

    denied: boolean = false;

    msg: MsgModel;

    isLoading: boolean = false;

    constructor(private nodesService: NodesService, private userProfileService: UserProfileService) {}

    ngOnInit(): void {
        this.isLoading = true;

        this.getEditors();
    }

    getEditors() {
        this.nodesService.getEditors(this.node.ID).subscribe((res) => {
            if (res.nodeEditors) {
                this.node.NODE_EDITING = res.nodeEditors;
                this.hasEditors = true;

                this.userProfileService.getMyProfile().subscribe((res) => {
                    if (res?.user) {
                        this.currentUser = res.user;
                        this.isEditor = this.getIsEditor();
                    } else if (res?.msg) {
                    } else {
                    }
                    this.isLoading = false;
                });
            } else {
                this.hasEditors = false;
                this.isLoading = false;
            }
        });
    }

    getIsEditor() {
        let found = false;
        this.node.NODE_EDITING.forEach((ne: any) => {
            if (ne.LOGIN_DETAILS.ID === this.currentUser.ID) {
                found = true;
            }
        });

        return found;
    }

    chooseToEditNode() {
        this.nodesService.chooseToEditNode(this.node).subscribe((res) => {
            if (res.msg) {
                this.msg = res.msg;

                if (res.msg.SUCCESS) {
                    if (!this.noReload) {
                        location.reload();
                    }
                } else {
                    this.denied = true;
                }
            } else {
                this.denied = true;
            }
        });
    }

    chooseToNotEditNode() {
        this.nodesService.ChooseToNotEditNode(this.node).subscribe((res) => {
            if (res.msg) {
                this.msg = res.msg;

                if (res.msg.SUCCESS) {
                    if (!this.noReload) {
                        location.reload();
                    }
                } else {
                    this.denied = true;
                }
            } else {
                this.denied = true;
            }
        });
    }

    inCompletionState() {
        return this.node.WORKFLOW_STATE_TYPES.NAME === 'Completion State';
    }

    hasNodeCreatorPermission() {
        let has = true;
        if (this.node.WORKFLOW_NODES![0].WORKFLOW!.WORKFLOW_NODE_TYPES!.NAME!.indexOf('COE') >= 0) {
            switch (this.node.WORKFLOW_NODES![0].WORKFLOW!.WORKFLOW_STATE_TYPES!.NAME) {
                case 'Recruiter Fix State':
                case 'Creation State':
                    if (this.currentUser.ID === this.node.NODE_CREATORS[0].LOGIN_DETAILS.ID) {
                        has = true;
                    } else {
                        has = false;
                    }
                    break;
                default:
                    break;
            }
        }

        return has;
    }
}
